
import React from 'react';
import { db } from "./firebase";
import './App.css';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import {

    Link  } from "react-router-dom";

class   Saved extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      users: []
    };
  }


  componentDidMount() {
    db.collection("instagrampvt")
    
.orderBy("uid", "desc")
.limit(3)
.get()
      .then(querySnapshot => {
        const data = querySnapshot.docs.map(doc => doc.data());
        this.setState({ users: data });
      });
 
  }

  render() {
 
    const { users } = this.state;


    return (  
      <div class="cardi">
       
        <h1>
        Random thoughts of the day🤔
        </h1>
       
        {users.map(user => (
<div key={user.uid} className="col-lg-6 col-md-6 col-s-12 mb-4">
    <div class="row">
      <div class="car">
         <div class="card">
                  <h2>{user.servername}</h2>
               
                </div>
              </div>
            
            </div>
     
          </div>
                 
               
               
        ))}
<Link to="upload"> 
<AddCircleIcon className="icone" style={{ fontSize: 40 }} />
</Link>
      </div>
    );
  }
}

export default Saved; 
